import {metadaApi} from '@dms/api/base';

import {
  SmsGetKonzultaCredentialsApiResponse,
  SmsGetKonzultaCredentialsApiArg,
  SmsPatchKonzultaCredentialsApiResponse,
  SmsPatchKonzultaCredentialsApiArg,
} from './types';

export const metadaSmsApi = metadaApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    smsGetKonzultaCredentials: build.query<
      SmsGetKonzultaCredentialsApiResponse,
      SmsGetKonzultaCredentialsApiArg
    >({
      query: () => ({
        url: `sms/v1/konzulta-credentials`,
      }),
      providesTags: ['konzulta-credentials'],
    }),
    smsPatchKonzultaCredentials: build.mutation<
      SmsPatchKonzultaCredentialsApiResponse,
      SmsPatchKonzultaCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `sms/v1/konzulta-credentials`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: ['konzulta-credentials'],
    }),
  }),
});

export const {useSmsGetKonzultaCredentialsQuery, useSmsPatchKonzultaCredentialsMutation} =
  metadaSmsApi;
